import { render, staticRenderFns } from "./CustomerContact.vue?vue&type=template&id=a3481228&scoped=true"
import script from "./CustomerContact.vue?vue&type=script&lang=js"
export * from "./CustomerContact.vue?vue&type=script&lang=js"
import style0 from "./CustomerContact.vue?vue&type=style&index=0&id=a3481228&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3481228",
  null
  
)

export default component.exports